var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounting1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1666.959,
    height: 519.66,
    viewBox: "0 0 1666.959 519.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Accounting1",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185137",
    "data-name": "\\uADF8\\uB8F9 185137"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154456",
    "data-name": "\\uC0AC\\uAC01\\uD615 154456",
    width: 191.635,
    height: 517.659,
    transform: "translate(638.127)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154456_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154456 - \\uC724\\uACFD\\uC120",
    d: "M0-1H191.635a1,1,0,0,1,1,1V517.659a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM190.635,1H1V516.659H190.635Z",
    transform: "translate(638.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154457",
    "data-name": "\\uC0AC\\uAC01\\uD615 154457",
    width: 595.114,
    height: 172.554,
    transform: "translate(95.646 305.761)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154457_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154457 - \\uC724\\uACFD\\uC120",
    d: "M0-1H595.114a1,1,0,0,1,1,1V172.554a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM594.114,1H1V171.554H594.114Z",
    transform: "translate(95.646 305.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154458",
    "data-name": "\\uC0AC\\uAC01\\uD615 154458",
    width: 191.635,
    height: 517.659,
    transform: "translate(829.519)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154458_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154458 - \\uC724\\uACFD\\uC120",
    d: "M0-1H191.635a1,1,0,0,1,1,1V517.659a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM190.635,1H1V516.659H190.635Z",
    transform: "translate(829.519)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154482",
    "data-name": "\\uC0AC\\uAC01\\uD615 154482",
    width: 10.761,
    height: 211.898,
    transform: "translate(701.892 305.761)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154482_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154482 - \\uC724\\uACFD\\uC120",
    d: "M0-1H10.761a1,1,0,0,1,1,1V211.9a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM9.761,1H1V210.9H9.761Z",
    transform: "translate(701.892 305.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1660",
    "data-name": "\\uC120 1660",
    d: "M1283.753,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H1283.753a1,1,0,0,1,1,1A1,1,0,0,1,1283.753,1Z",
    transform: "translate(195.964 517.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1669",
    "data-name": "\\uC120 1669",
    d: "M67.144.749H0A.749.749,0,0,1-.749,0,.749.749,0,0,1,0-.749H67.144A.749.749,0,0,1,67.893,0,.749.749,0,0,1,67.144.749Z",
    transform: "translate(1598.066 517.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132697",
    "data-name": "\\uD328\\uC2A4 132697",
    d: "M196,479.2H839.761V464.482H196",
    transform: "translate(-100.354 -173.351)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132697_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132697 - \\uC724\\uACFD\\uC120",
    d: "M839.761,480.2H196a1,1,0,0,1,0-2H838.761V465.482H196a1,1,0,0,1,0-2H839.761a1,1,0,0,1,1,1V479.2A1,1,0,0,1,839.761,480.2Z",
    transform: "translate(-100.354 -173.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1672",
    "data-name": "\\uC120 1672",
    d: "M162.156,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H162.156a1,1,0,0,1,1,1A1,1,0,0,1,162.156,1Z",
    transform: "translate(0 514.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185114",
    "data-name": "\\uADF8\\uB8F9 185114",
    transform: "translate(446.223 143.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154495",
    "data-name": "\\uC0AC\\uAC01\\uD615 154495",
    width: 229.024,
    height: 127.209,
    rx: 5.602,
    transform: "translate(8.954)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154495_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154495 - \\uC724\\uACFD\\uC120",
    d: "M5.6-1h217.82a6.609,6.609,0,0,1,6.6,6.6V121.608a6.609,6.609,0,0,1-6.6,6.6H5.6a6.609,6.609,0,0,1-6.6-6.6V5.6A6.609,6.609,0,0,1,5.6-1Zm217.82,127.209a4.607,4.607,0,0,0,4.6-4.6V5.6a4.607,4.607,0,0,0-4.6-4.6H5.6A4.607,4.607,0,0,0,1,5.6V121.608a4.607,4.607,0,0,0,4.6,4.6Z",
    transform: "translate(8.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154496",
    "data-name": "\\uC0AC\\uAC01\\uD615 154496",
    width: 213.369,
    height: 104.222,
    transform: "translate(16.781 11.494)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154496_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154496 - \\uC724\\uACFD\\uC120",
    d: "M0-1H213.369a1,1,0,0,1,1,1V104.222a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM212.369,1H1V103.222H212.369Z",
    transform: "translate(16.781 11.494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185113",
    "data-name": "\\uADF8\\uB8F9 185113",
    transform: "translate(85.437 47.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1673",
    "data-name": "\\uC120 1673",
    d: "M12.328,13.328a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L13.035,11.621a1,1,0,0,1-.707,1.707Z",
    transform: "translate(0 9.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1674",
    "data-name": "\\uC120 1674",
    d: "M12.328,13.328a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L13.035,11.621a1,1,0,0,1-.707,1.707Z",
    transform: "translate(32.299 9.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1675",
    "data-name": "\\uC120 1675",
    d: "M24.194,25.194a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L24.9,23.487a1,1,0,0,1-.707,1.707Z",
    transform: "translate(42.516 4.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1676",
    "data-name": "\\uC120 1676",
    d: "M10.591,11.591a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L11.3,9.883a1,1,0,0,1-.707,1.707Z",
    transform: "translate(65.467 10.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1677",
    "data-name": "\\uC120 1677",
    d: "M32.241,33.241a1,1,0,0,1-.707-.293L-.707.707a1,1,0,0,1,0-1.414,1,1,0,0,1,1.414,0L32.948,31.534a1,1,0,0,1-.707,1.707Z",
    transform: "translate(6.193)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154497",
    "data-name": "\\uC0AC\\uAC01\\uD615 154497",
    d: "M0,0H246.932a0,0,0,0,1,0,0V10.658A5.345,5.345,0,0,1,241.587,16H5.345A5.345,5.345,0,0,1,0,10.658V0A0,0,0,0,1,0,0Z",
    transform: "translate(0 132.037)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154497_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154497 - \\uC724\\uACFD\\uC120",
    d: "M0-1H246.932a1,1,0,0,1,1,1V10.658A6.352,6.352,0,0,1,241.587,17H5.345A6.352,6.352,0,0,1-1,10.658V0A1,1,0,0,1,0-1ZM245.932,1H1v9.658A4.35,4.35,0,0,0,5.345,15H241.587a4.35,4.35,0,0,0,4.345-4.345Z",
    transform: "translate(0 132.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154498",
    "data-name": "\\uC0AC\\uAC01\\uD615 154498",
    width: 169.907,
    height: 7.991,
    transform: "translate(37.034 123.598)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154498_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154498 - \\uC724\\uACFD\\uC120",
    d: "M0-1H169.907a1,1,0,0,1,1,1V7.991a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM168.907,1H1V6.991H168.907Z",
    transform: "translate(37.034 123.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154499",
    "data-name": "\\uC0AC\\uAC01\\uD615 154499",
    width: 63.91,
    height: 8.001,
    transform: "translate(91.511 132.037)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154499_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154499 - \\uC724\\uACFD\\uC120",
    d: "M0-1H63.91a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1H0A1,1,0,0,1-1,8V0A1,1,0,0,1,0-1ZM62.91,1H1V7H62.91Z",
    transform: "translate(91.511 132.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC120_1678",
    "data-name": "\\uC120 1678",
    d: "M0,9A1,1,0,0,1-1,8V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V8A1,1,0,0,1,0,9Z",
    transform: "translate(123.9 132.037)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154500",
    "data-name": "\\uC0AC\\uAC01\\uD615 154500",
    width: 8.085,
    height: 53.405,
    transform: "translate(806.847 252.94)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154500_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154500 - \\uC724\\uACFD\\uC120",
    d: "M0-1H8.085a1,1,0,0,1,1,1V53.405a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM7.085,1H1V52.405H7.085Z",
    transform: "translate(806.847 252.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154501",
    "data-name": "\\uC0AC\\uAC01\\uD615 154501",
    width: 31.929,
    height: 517.659,
    transform: "translate(989.145)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154501_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154501 - \\uC724\\uACFD\\uC120",
    d: "M0-1H31.929a1,1,0,0,1,1,1V517.659a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM30.929,1H1V516.659H30.929Z",
    transform: "translate(989.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154502",
    "data-name": "\\uC0AC\\uAC01\\uD615 154502",
    width: 13.98,
    height: 517.659,
    transform: "translate(975.194)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154502_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154502 - \\uC724\\uACFD\\uC120",
    d: "M0-1H13.98a1,1,0,0,1,1,1V517.659a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM12.98,1H1V516.659H12.98Z",
    transform: "translate(975.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154503",
    "data-name": "\\uC0AC\\uAC01\\uD615 154503",
    width: 145.726,
    height: 9.361,
    transform: "translate(829.551 111.528)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154503_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154503 - \\uC724\\uACFD\\uC120",
    d: "M0-1H145.726a1,1,0,0,1,1,1V9.361a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM144.726,1H1V8.361H144.726Z",
    transform: "translate(829.551 111.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154504",
    "data-name": "\\uC0AC\\uAC01\\uD615 154504",
    width: 145.726,
    height: 9.361,
    transform: "translate(829.551 270.294)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154504_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154504 - \\uC724\\uACFD\\uC120",
    d: "M0-1H145.726a1,1,0,0,1,1,1V9.361a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM144.726,1H1V8.361H144.726Z",
    transform: "translate(829.551 270.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154505",
    "data-name": "\\uC0AC\\uAC01\\uD615 154505",
    width: 145.726,
    height: 9.361,
    transform: "translate(829.551 434.761)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154505_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154505 - \\uC724\\uACFD\\uC120",
    d: "M0-1H145.726a1,1,0,0,1,1,1V9.361a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM144.726,1H1V8.361H144.726Z",
    transform: "translate(829.551 434.761)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154506",
    "data-name": "\\uC0AC\\uAC01\\uD615 154506",
    width: 23.96,
    height: 93.551,
    transform: "translate(829.627 17.977)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154506_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154506 - \\uC724\\uACFD\\uC120",
    d: "M0-1H23.96a1,1,0,0,1,1,1V93.551a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM22.96,1H1V92.551H22.96Z",
    transform: "translate(829.627 17.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154507",
    "data-name": "\\uC0AC\\uAC01\\uD615 154507",
    width: 23.96,
    height: 89.689,
    transform: "translate(829.627 180.606)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154507_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154507 - \\uC724\\uACFD\\uC120",
    d: "M0-1H23.96a1,1,0,0,1,1,1V89.689a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM22.96,1H1V88.689H22.96Z",
    transform: "translate(829.627 180.606)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154508",
    "data-name": "\\uC0AC\\uAC01\\uD615 154508",
    width: 23.96,
    height: 93.551,
    transform: "translate(852.677 17.977)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154508_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154508 - \\uC724\\uACFD\\uC120",
    d: "M0-1H23.96a1,1,0,0,1,1,1V93.551a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM22.96,1H1V92.551H22.96Z",
    transform: "translate(852.677 17.977)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21797",
    "data-name": "\\uD0C0\\uC6D0 21797",
    cx: 5.51,
    cy: 5.51,
    rx: 5.51,
    ry: 5.51,
    transform: "translate(859.148 31.634)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21797_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21797 - \\uC724\\uACFD\\uC120",
    d: "M5.51-1A6.51,6.51,0,1,1-1,5.51,6.517,6.517,0,0,1,5.51-1Zm0,11.02A4.51,4.51,0,1,0,1,5.51,4.515,4.515,0,0,0,5.51,10.02Z",
    transform: "translate(859.148 31.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21798",
    "data-name": "\\uD0C0\\uC6D0 21798",
    cx: 5.51,
    cy: 5.51,
    rx: 5.51,
    ry: 5.51,
    transform: "translate(836.096 31.634)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21798_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21798 - \\uC724\\uACFD\\uC120",
    d: "M5.51-1A6.51,6.51,0,1,1-1,5.51,6.517,6.517,0,0,1,5.51-1Zm0,11.02A4.51,4.51,0,1,0,1,5.51,4.515,4.515,0,0,0,5.51,10.02Z",
    transform: "translate(836.096 31.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185115",
    "data-name": "\\uADF8\\uB8F9 185115",
    transform: "translate(854.199 253.671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154509",
    "data-name": "\\uC0AC\\uAC01\\uD615 154509",
    width: 15.656,
    height: 85.525,
    transform: "translate(85.525 0) rotate(90)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154509_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154509 - \\uC724\\uACFD\\uC120",
    d: "M0-1H15.656a1,1,0,0,1,1,1V85.525a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM14.656,1H1V84.525H14.656Z",
    transform: "translate(85.525 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154510",
    "data-name": "\\uC0AC\\uAC01\\uD615 154510",
    width: 5.992,
    height: 15.656,
    transform: "translate(69.423)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154510_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154510 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V15.656a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V14.656H4.992Z",
    transform: "translate(69.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154511",
    "data-name": "\\uC0AC\\uAC01\\uD615 154511",
    width: 5.992,
    height: 15.656,
    transform: "translate(63.431)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154511_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154511 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V15.656a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V14.656H4.992Z",
    transform: "translate(63.431)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154512",
    "data-name": "\\uC0AC\\uAC01\\uD615 154512",
    width: 5.992,
    height: 15.656,
    transform: "translate(16.394)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154512_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154512 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V15.656a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V14.656H4.992Z",
    transform: "translate(16.394)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154513",
    "data-name": "\\uC0AC\\uAC01\\uD615 154513",
    width: 5.992,
    height: 15.656,
    transform: "translate(10.402)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154513_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154513 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V15.656a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V14.656H4.992Z",
    transform: "translate(10.402)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185116",
    "data-name": "\\uADF8\\uB8F9 185116",
    transform: "translate(854.199 242.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154514",
    "data-name": "\\uC0AC\\uAC01\\uD615 154514",
    width: 10.261,
    height: 85.525,
    transform: "translate(85.525 0) rotate(90)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154514_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154514 - \\uC724\\uACFD\\uC120",
    d: "M0-1H10.261a1,1,0,0,1,1,1V85.525a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM9.261,1H1V84.525H9.261Z",
    transform: "translate(85.525 0) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154515",
    "data-name": "\\uC0AC\\uAC01\\uD615 154515",
    width: 5.992,
    height: 10.261,
    transform: "translate(69.423 0)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154515_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154515 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V10.261a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V9.261H4.992Z",
    transform: "translate(69.423 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154516",
    "data-name": "\\uC0AC\\uAC01\\uD615 154516",
    width: 5.992,
    height: 10.261,
    transform: "translate(63.431 0)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154516_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154516 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V10.261a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V9.261H4.992Z",
    transform: "translate(63.431 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154517",
    "data-name": "\\uC0AC\\uAC01\\uD615 154517",
    width: 5.992,
    height: 10.261,
    transform: "translate(16.394 0)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154517_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154517 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V10.261a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V9.261H4.992Z",
    transform: "translate(16.394 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154518",
    "data-name": "\\uC0AC\\uAC01\\uD615 154518",
    width: 5.992,
    height: 10.261,
    transform: "translate(10.402 0)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154518_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154518 - \\uC724\\uACFD\\uC120",
    d: "M0-1H5.992a1,1,0,0,1,1,1V10.261a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM4.992,1H1V9.261H4.992Z",
    transform: "translate(10.402 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_185117",
    "data-name": "\\uADF8\\uB8F9 185117",
    transform: "translate(179.714 172.724)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21799",
    "data-name": "\\uD0C0\\uC6D0 21799",
    cx: 9.186,
    cy: 9.186,
    rx: 9.186,
    ry: 9.186,
    transform: "translate(48.89 326.563)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21799_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21799 - \\uC724\\uACFD\\uC120",
    d: "M9.186-1A10.186,10.186,0,1,1-1,9.186,10.2,10.2,0,0,1,9.186-1Zm0,18.372A8.186,8.186,0,1,0,1,9.186,8.2,8.2,0,0,0,9.186,17.372Z",
    transform: "translate(48.89 326.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21800",
    "data-name": "\\uD0C0\\uC6D0 21800",
    cx: 9.186,
    cy: 9.186,
    rx: 9.186,
    ry: 9.186,
    transform: "translate(212.351 326.563)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21800_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21800 - \\uC724\\uACFD\\uC120",
    d: "M9.186-1A10.186,10.186,0,1,1-1,9.186,10.2,10.2,0,0,1,9.186-1Zm0,18.372A8.186,8.186,0,1,0,1,9.186,8.2,8.2,0,0,0,9.186,17.372Z",
    transform: "translate(212.351 326.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_21801",
    "data-name": "\\uD0C0\\uC6D0 21801",
    cx: 9.186,
    cy: 9.186,
    rx: 9.186,
    ry: 9.186,
    transform: "translate(130.891 326.563)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD0C0\\uC6D0_21801_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD0C0\\uC6D0 21801 - \\uC724\\uACFD\\uC120",
    d: "M9.186-1A10.186,10.186,0,1,1-1,9.186,10.2,10.2,0,0,1,9.186-1Zm0,18.372A8.186,8.186,0,1,0,1,9.186,8.2,8.2,0,0,0,9.186,17.372Z",
    transform: "translate(130.891 326.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154519",
    "data-name": "\\uC0AC\\uAC01\\uD615 154519",
    width: 24.201,
    height: 38.349,
    transform: "translate(251.743 158.787)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154519_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154519 - \\uC724\\uACFD\\uC120",
    d: "M0-1H24.2a1,1,0,0,1,1,1V38.349a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM23.2,1H1V37.349H23.2Z",
    transform: "translate(251.743 158.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154520",
    "data-name": "\\uC0AC\\uAC01\\uD615 154520",
    width: 24.201,
    height: 38.349,
    transform: "translate(4.149 158.787)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154520_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154520 - \\uC724\\uACFD\\uC120",
    d: "M0-1H24.2a1,1,0,0,1,1,1V38.349a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM23.2,1H1V37.349H23.2Z",
    transform: "translate(4.149 158.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154521",
    "data-name": "\\uC0AC\\uAC01\\uD615 154521",
    d: "M5.093,0H27.406A5.093,5.093,0,0,1,32.5,5.093V16.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.093A5.093,5.093,0,0,1,5.093,0Z",
    transform: "translate(0 150.272)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154521_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154521 - \\uC724\\uACFD\\uC120",
    d: "M5.093-1H27.406A6.1,6.1,0,0,1,33.5,5.093V16.9a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V5.093A6.1,6.1,0,0,1,5.093-1ZM31.5,15.9V5.093A4.1,4.1,0,0,0,27.406,1H5.093A4.1,4.1,0,0,0,1,5.093V15.9Z",
    transform: "translate(0 150.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154522",
    "data-name": "\\uC0AC\\uAC01\\uD615 154522",
    d: "M5.093,0H27.406A5.093,5.093,0,0,1,32.5,5.093V16.9a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V5.093A5.093,5.093,0,0,1,5.093,0Z",
    transform: "translate(247.594 150.272)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154522_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154522 - \\uC724\\uACFD\\uC120",
    d: "M5.093-1H27.406A6.1,6.1,0,0,1,33.5,5.093V16.9a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V5.093A6.1,6.1,0,0,1,5.093-1ZM31.5,15.9V5.093A4.1,4.1,0,0,0,27.406,1H5.093A4.1,4.1,0,0,0,1,5.093V15.9Z",
    transform: "translate(247.594 150.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154523",
    "data-name": "\\uC0AC\\uAC01\\uD615 154523",
    d: "M0,0H271.8a0,0,0,0,1,0,0V7.507a4.477,4.477,0,0,1-4.477,4.477H4.477A4.477,4.477,0,0,1,0,7.507V0A0,0,0,0,1,0,0Z",
    transform: "translate(4.149 197.136)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154523_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154523 - \\uC724\\uACFD\\uC120",
    d: "M0-1H271.8a1,1,0,0,1,1,1V7.507a5.484,5.484,0,0,1-5.477,5.477H4.477A5.484,5.484,0,0,1-1,7.507V0A1,1,0,0,1,0-1ZM270.8,1H1V7.507a3.481,3.481,0,0,0,3.477,3.477H267.318A3.481,3.481,0,0,0,270.8,7.507Z",
    transform: "translate(4.149 197.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132698",
    "data-name": "\\uD328\\uC2A4 132698",
    d: "M417.571,648.146H280.086a33.12,33.12,0,0,1-32.865-37.2l20.648-166.25a33.121,33.121,0,0,1,32.868-29.037h96.185a33.119,33.119,0,0,1,32.865,29.037l20.648,166.253A33.119,33.119,0,0,1,417.571,648.146Z",
    transform: "translate(-208.782 -415.656)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132698_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132698 - \\uC724\\uACFD\\uC120",
    d: "M417.571,649.146H280.086a34.085,34.085,0,0,1-33.858-38.326l20.648-166.25a34.121,34.121,0,0,1,33.86-29.914h96.185A34.119,34.119,0,0,1,430.78,444.57l20.648,166.253a34.083,34.083,0,0,1-33.858,38.323ZM300.737,416.656a32.121,32.121,0,0,0-31.875,28.16l-20.648,166.25a32.084,32.084,0,0,0,31.873,36.079H417.571a32.084,32.084,0,0,0,31.873-36.077L428.8,444.816a32.119,32.119,0,0,0-31.873-28.16Z",
    transform: "translate(-208.782 -415.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154524",
    "data-name": "\\uC0AC\\uAC01\\uD615 154524",
    width: 27.563,
    height: 79.694,
    transform: "translate(126.265 232.489)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154524_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154524 - \\uC724\\uACFD\\uC120",
    d: "M0-1H27.563a1,1,0,0,1,1,1V79.694a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM26.563,1H1V78.694H26.563Z",
    transform: "translate(126.265 232.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132699",
    "data-name": "\\uD328\\uC2A4 132699",
    d: "M331.57,545.8l-82.12,11.385v7.79l95.9-4.194V545.8Z",
    transform: "translate(-205.305 -233.617)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132699_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132699 - \\uC724\\uACFD\\uC120",
    d: "M331.57,544.8h13.782a1,1,0,0,1,1,1v14.98a1,1,0,0,1-.956,1l-95.9,4.194a1,1,0,0,1-1.044-1v-7.79a1,1,0,0,1,.863-.991l82.12-11.385A1,1,0,0,1,331.57,544.8Zm12.782,2H331.639L250.45,558.055v5.874l93.9-4.107Z",
    transform: "translate(-205.305 -233.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132700",
    "data-name": "\\uD328\\uC2A4 132700",
    d: "M303.211,545.8l82.12,11.385v7.79l-95.9-4.194V545.8Z",
    transform: "translate(-149.383 -233.617)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132700_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132700 - \\uC724\\uACFD\\uC120",
    d: "M289.43,544.8h13.782a1,1,0,0,1,.137.009l82.12,11.385a1,1,0,0,1,.863.991v7.79a1,1,0,0,1-1.044,1l-95.9-4.194a1,1,0,0,1-.956-1V545.8A1,1,0,0,1,289.43,544.8Zm13.713,2H290.43v13.023l93.9,4.107v-5.874Z",
    transform: "translate(-149.383 -233.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154525",
    "data-name": "\\uC0AC\\uAC01\\uD615 154525",
    width: 13.902,
    height: 19.174,
    transform: "translate(133.095 312.182)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154525_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154525 - \\uC724\\uACFD\\uC120",
    d: "M0-1H13.9a1,1,0,0,1,1,1V19.174a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM12.9,1H1V18.174H12.9Z",
    transform: "translate(133.095 312.182)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154526",
    "data-name": "\\uC0AC\\uAC01\\uD615 154526",
    d: "M0-1H117.75a1,1,0,0,1,1,1V70.106a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM116.75,1H1V69.106H116.75Z",
    transform: "translate(276.56 3.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_154527",
    "data-name": "\\uC0AC\\uAC01\\uD615 154527",
    width: 81.866,
    height: 34.154,
    transform: "translate(294.489 21.398)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_154527_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uC0AC\\uAC01\\uD615 154527 - \\uC724\\uACFD\\uC120",
    d: "M0-1H81.866a1,1,0,0,1,1,1V34.154a1,1,0,0,1-1,1H0a1,1,0,0,1-1-1V0A1,1,0,0,1,0-1ZM80.866,1H1V33.154H80.866Z",
    transform: "translate(294.489 21.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132701",
    "data-name": "\\uD328\\uC2A4 132701",
    d: "M354.3,370.3v2.5h-7.437v10H342.04v-4.787h-5.5v11.961h-4.046V372.794h-7.72v11.341H314.3v-6.893H303.963v12.73h-7.431v-3.185h-7.159v-5.353H279.04V398.51H359.8V370.3Z",
    transform: "translate(15.449 -342.957)",
    fill: "#1876d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132701_-_\\uC724\\uACFD\\uC120",
    "data-name": "\\uD328\\uC2A4 132701 - \\uC724\\uACFD\\uC120",
    d: "M354.3,369.3h5.5a1,1,0,0,1,1,1V398.51a1,1,0,0,1-1,1H279.04a1,1,0,0,1-1-1V381.433a1,1,0,0,1,1-1h10.334a1,1,0,0,1,1,1v4.353h6.159a1,1,0,0,1,1,1v2.185h5.431v-11.73a1,1,0,0,1,1-1H314.3a1,1,0,0,1,1,1v5.893h8.478V372.794a1,1,0,0,1,1-1h7.72a1,1,0,0,1,1,1v16.177h2.046V378.011a1,1,0,0,1,1-1h5.5a1,1,0,0,1,1,1V381.8h2.823v-9a1,1,0,0,1,1-1H353.3v-1.5A1,1,0,0,1,354.3,369.3Zm4.5,2h-3.5v1.5a1,1,0,0,1-1,1h-6.437v9a1,1,0,0,1-1,1H342.04a1,1,0,0,1-1-1v-3.787h-3.5v10.961a1,1,0,0,1-1,1h-4.046a1,1,0,0,1-1-1V373.794h-5.72v10.341a1,1,0,0,1-1,1H314.3a1,1,0,0,1-1-1v-5.893h-8.334v11.73a1,1,0,0,1-1,1h-7.431a1,1,0,0,1-1-1v-2.185h-6.159a1,1,0,0,1-1-1v-4.353H280.04V397.51H358.8Z",
    transform: "translate(15.449 -342.957)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting1);
export default __webpack_public_path__ + "static/media/Accounting1.5e2b44e652fba4b2a0de364e8ffc83eb.svg";
export { ForwardRef as ReactComponent };